import {
  AppleOutlined,
  CreditCardOutlined,
  WalletOutlined,
} from "@ant-design/icons";
import { Status, StatusVariant } from "components";
import { BookingStatus, PaymentMethod } from "types";

const gameStatusMap = {
  [BookingStatus.active]: StatusVariant.success,
  [BookingStatus.cancelled]: StatusVariant.error,
  [BookingStatus.completed]: StatusVariant.default,
};

export const handleRenderStatus = (item: {
  is_cancelled?: boolean;
  end_date: string | Date;
}) => {
  if (item.is_cancelled)
    return (
      <Status variant={gameStatusMap[BookingStatus.cancelled]}>
        <Status.BadgeWithText text={BookingStatus.cancelled} />
      </Status>
    );
  const now = new Date();
  const itemDate = new Date(item?.end_date);

  if (itemDate < now)
    return (
      <Status variant={gameStatusMap[BookingStatus.completed]}>
        <Status.BadgeWithText text={BookingStatus.completed} />
      </Status>
    );

  return (
    <Status variant={gameStatusMap[BookingStatus.active]}>
      <Status.BadgeWithText text={BookingStatus.active} />
    </Status>
  );
};

export const paymentMethodIconMap: { [key in PaymentMethod]: JSX.Element } = {
  // [PaymentMethod.Cash]: <>Cash</>,
  // [PaymentMethod.Knet]: <>Knet</>,
  // [PaymentMethod.Wallet]: <>Wallet</>,
  // [PaymentMethod.Credit]: <>Credit</>,
  // [PaymentMethod.Apple]: <>Apple</>,

  [PaymentMethod.Cash]: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      width={"17px"}
    >
      <path d="M12.0004 16C14.2095 16 16.0004 14.2091 16.0004 12 16.0004 9.79086 14.2095 8 12.0004 8 9.79123 8 8.00037 9.79086 8.00037 12 8.00037 14.2091 9.79123 16 12.0004 16ZM21.0049 4.00293H3.00488C2.4526 4.00293 2.00488 4.45064 2.00488 5.00293V19.0029C2.00488 19.5552 2.4526 20.0029 3.00488 20.0029H21.0049C21.5572 20.0029 22.0049 19.5552 22.0049 19.0029V5.00293C22.0049 4.45064 21.5572 4.00293 21.0049 4.00293ZM4.00488 15.6463V8.35371C5.13065 8.017 6.01836 7.12892 6.35455 6.00293H17.6462C17.9833 7.13193 18.8748 8.02175 20.0049 8.3564V15.6436C18.8729 15.9788 17.9802 16.8711 17.6444 18.0029H6.3563C6.02144 16.8742 5.13261 15.9836 4.00488 15.6463Z"></path>
    </svg>
  ),
  [PaymentMethod.Knet]: <CreditCardOutlined />,
  [PaymentMethod.Wallet]: <WalletOutlined />,
  [PaymentMethod.Credit]: <CreditCardOutlined />,
  [PaymentMethod.Apple]: <AppleOutlined />,
  [PaymentMethod.Online]: <AppleOutlined />,
};
